import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { IStrapiEntity } from '@core/interfaces/strapi.interface';
import { ArticleHeroImports } from '@pages/articles/article-page/hero/article-hero.imports';
import { IArticle, IAuthor, ICaseInfo } from '@pages/articles/interfaces/article.interface';

@Component({
  selector: 'noda-article-hero',
  standalone: true,
  templateUrl: './article-hero.component.html',
  styleUrls: ['./article-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ArticleHeroImports,
})
export class ArticleHeroComponent {
  public article: InputSignal<IArticle> = input.required<IArticle>();
  public caseInfo: Signal<ICaseInfo> = computed((): ICaseInfo => this.article().caseInfo);
  public author: Signal<IStrapiEntity<IAuthor>> = computed(
    (): IStrapiEntity<IAuthor> => this.article().author.data,
  );
  public reviewer: Signal<IStrapiEntity<IAuthor>> = computed(
    (): IStrapiEntity<IAuthor> => this.article().reviewer.data,
  );
  public showAuthors: Signal<boolean> = computed((): boolean => {
    return this.author() && !this.caseInfo();
  });
}
